import {
  CellTowerIcon,
  CogIcon,
  EditIcon,
  FeedIcon,
  IconButton,
  Menu,
  MoreIcon,
  NumberedListIcon,
  Popover,
  Position,
  RemoveIcon,
  SendToGraphIcon
} from 'evergreen-ui';
import {
  CHANNELS,
  CONFINES,
  DATASOURCES,
  NEW,
  SEBA_MAPPING,
  SETTINGS,
  TELEGRAMS
} from 'Features/routePaths';
import React from 'react';
import { Link } from 'react-router-dom';
import { StationType } from 'Services/api/v2';
import { DialogStationDelete } from './DialogStationDelete';
import { getStationPath } from './utils';

type StationMenuProps = {
  station: StationType,
  isStationAdmin: boolean,
}

/** Меню станции. Отображается, если пользователь админ станции */
export function StationMenu({ station, isStationAdmin }:StationMenuProps) {
  const [isShownDelete, setIsShownDelete] = React.useState(false);
  const deleteStation = () => setIsShownDelete(true);

  if (!isStationAdmin) return null;
  return (
    <>
      <DialogStationDelete station={station} isShown={isShownDelete} onClose={setIsShownDelete} />
      <Popover
        position={Position.BOTTOM_RIGHT}
        content={({ close }) => StationPopoverContentMenu({ close, station, deleteStation })}
      >
        <IconButton
          icon={MoreIcon}
          appearance="minimal"
        />
      </Popover>
    </>

  );
}
export const MemoStationMenu = React.memo(StationMenu);
MemoStationMenu.displayName = 'MemoStationMenu';
export default StationMenu;

/**
 * Меню к `StationMenu`
*/
// note: так как это скрывающаяся часть в портале, то ничего не мемоизирую (не имеет смысла)
function StationPopoverContentMenu(
  { close, station, deleteStation }:
  { close: () => void, station: StationType, deleteStation: () => void },
) {
  const stationPath = getStationPath(station.id);
  // с учетом, что переход будет по `{stationPath}/{to}`
  const menu = [
    {
      to: '', // переход по пути stationPath
      name: 'Редактировать станцию...',
      icon: EditIcon,
    },
    {
      to: CONFINES,
      name: 'Редактировать пределы...',
      icon: NumberedListIcon,
    },
    {
      to: SEBA_MAPPING,
      name: 'Настройка расположения...',
      icon: CogIcon,
    },
    {
      to: `${DATASOURCES}/${NEW}`,
      name: 'Добавить источник данных...',
      icon: SendToGraphIcon,
    },
    {
      to: `${TELEGRAMS}/${SETTINGS}`,
      name: 'Настройка телеграмм...',
      icon: CellTowerIcon,
    },
    {
      to: CHANNELS,
      name: 'Настройка каналов отправки...',
      icon: FeedIcon,
    },
  ];
  const onSelectDeleteStation = () => {
    deleteStation();
    close();
  };

  return (
    <Menu>
      <Menu.Group>
        {
          menu.map(({ to, icon, name }) => (
            <Menu.Item
              key={`${stationPath}/${to}`}
              is={Link}
              to={`${stationPath}/${to}`}
              icon={icon}
              onSelect={close}
            >
              {`${name}`}
            </Menu.Item>
          ))
        }

        <Menu.Divider />

        <Menu.Item
          onSelect={onSelectDeleteStation}
          icon={RemoveIcon}
          intent="danger"
        >
          Удалить станцию...
        </Menu.Item>
      </Menu.Group>
    </Menu>
  );
}
